<template>
  <v-dialog v-model="dialog" width="500" persistent scrollable>
    <v-card>
      <AdCardTitle dialog>{{ $t('select-parent-cardinality-title') }}</AdCardTitle>
      <v-card-text class="pa-0 pt-4 px-4">
        <p>{{ $t('select-parent-cardinality-description') }}</p>
        <EditableDropdown
          v-model="value"
          :label="$t('cardinality')"
          :items="cardinalities"
          item-value="name"
          item-text="name"
          return-object
        />
      </v-card-text>
      <v-card-actions class="dialogbottomstrip">
        <v-spacer/>
        <AdButton
          type="cancel"
          @click="cancel"
          :disabled="disabled"
        />
        <AdButton
          type="save"
          :text="$t('save')"
          @click="save"
          :disabled="disabled"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ScenarioParentCardinalityDialog',

  data () {
    return {
      value: null,
      dialog: false,
      callback: null,
      cardinalities: [{
        name: '0..1 R',
        itemMin: '0',
        itemMax: '1',
        itemConf: 'R'
      }, {
        name: '1..1 R',
        type: 'item',
        itemMin: '1',
        itemMax: '1',
        itemConf: 'R'
      }, {
        name: '1..1 M',
        type: 'item',
        itemMin: '1',
        itemMax: '1',
        itemConf: 'M'
      }, {
        name: '0..* R',
        type: 'item',
        itemMin: '0',
        itemMax: '*',
        itemConf: 'R'
      }, {
        name: '1..* R',
        type: 'item',
        itemMin: '1',
        itemMax: '*',
        itemConf: 'R'
      }, {
        name: '1..* M',
        type: 'item',
        itemMin: '1',
        itemMax: '*',
        itemConf: 'M'
      }]
    }
  },

  computed: {
    disabled () {
      return !this.value
    }
  },

  methods: {
    show (data, callback) {
      this.value = this.cardinalities.find((cardinality) => {
        return cardinality.itemConf === data?.itemConf &&
          cardinality.itemMax === data?.itemMax &&
          cardinality.itemMin === data?.itemMin
      })

      this.callback = callback
      this.dialog = true
    },

    cancel () {
      this.dialog = false
      this.value = null
    },

    save () {
      this.callback(this.value)
      this.dialog = false
      this.value = null
    }
  }
}
</script>
